import styles from "./index.module.css";
import { useContext, useEffect, useState } from "react";
import { Button } from "antd";
import { joinArbitrToDebateChat } from "helpers/backend_helper";
import { useRequest } from "ahooks";
import { AdminContext, Chats, initialMessages } from "context/adminContext";
import { NotificationContext } from "context/notificationContext";
import { useArbitrSocket } from "hooks/useArbitrSocket";
import { ChatDisput } from "pages/Main/Components/Chat";

type Props = {
  idChat: string;
  className?: string;
  debateId?: string;
  avatar?: string;
  userId: string;
};
export const UserDisputChat = ({ idChat, className, debateId }: Props) => {
  const [revealedChat, setRevealedChat] = useState<boolean>(false);
  const { openNotificationWithIcon } = useContext(NotificationContext);
  const { localCountry, setChats } = useContext(AdminContext);
  const {
    joinChatArbitr,
    leaveChatArbitr,
    sendMessageArbitr,
    messages,
    historyLoading,
    cursor,
    getDebateHistory,
    hasMore: hasMoreDebate,
  } = useArbitrSocket(idChat);

  const { run: startChatDebate } = useRequest(() => joinArbitrToDebateChat(debateId, localCountry?.iso), {
    manual: true,
    ready: !!debateId,
    refreshDeps: [debateId],
    onError: (error: any) => {
      openNotificationWithIcon("error", error.response?.data?.message || error.message);
    },
    onSuccess: () => {
      getDebateHistory(0);
      joinChatArbitr(idChat);
      setRevealedChat(true);
    },
  });
  useEffect(() => {
    return () => {
      leaveChatArbitr(idChat);
      setChats({ supportChat: initialMessages, debateChat: initialMessages } as Chats);
    };
  }, [idChat]);

  return (
    <div className={className ? className + " " + styles.container : styles.container}>
      {!revealedChat && (
        <div className={styles.layer}>
          <div>You have no messages</div>
          <Button
            type="primary"
            className={styles.button}
            onClick={() => {
              setChats({
                debateChat: { cursor: 0, messages: [] },
                selected: null,
                supportChat: { cursor: 0, messages: [] },
              });
              startChatDebate();
            }}
          >
            Reveal Chat
          </Button>
        </div>
      )}
      <ChatDisput
        data={{ chatData: revealedChat ? messages : initialMessages }}
        flags={{
          hasMore: revealedChat ? hasMoreDebate.current : false,
          loading: historyLoading,
        }}
        handlers={{
          loadMore: (cursor) => getDebateHistory(cursor),
          // hasMore = false — история заменяется, а не дописывается
          reloadHistory: () => {
            hasMoreDebate.current = false;
            getDebateHistory(0);
          },
          sendSocketMessage: sendMessageArbitr,
        }}
        ids={{ chatId: idChat, cursor }}
      />
    </div>
  );
};
